import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const MERCH_DESIGNS = [
  {
    name: "Men's Premium T-Shirt",
    price: '$26.99',
    img: 'https://image.spreadshirtmedia.com/image-server/v1/products/T812A1269PA4267PT17X48Y66D1058516213W25000H10560/views/1,width=500,height=500,appearanceId=1269/dirty-birdy-logo-mens-premium-t-shirt.jpg',
    href: 'https://tweettwice.myspreadshop.com/dirty+birdy+logo-A69bdd52b8c78661dd89ca359?productType=812&sellable=J1LBzMg1dxHpM8Jla8ja-812-7&appearance=1269',
  },
  {
    name: "Women's Premium T-Shirt",
    price: '$26.99',
    img: 'https://image.spreadshirtmedia.com/image-server/v1/products/T813A1PA4249PT17X14Y47D1058516213W25000H10560/views/1,width=500,height=500,appearanceId=1/dirty-birdy-logo-womens-premium-t-shirt.jpg',
    href: 'https://tweettwice.myspreadshop.com/dirty+birdy+logo-A69bdd52b8c78661dd89ca359?productType=813&sellable=J1LBzMg1dxHpM8Jla8ja-813-8&appearance=1',
  },
  {
    name: "Men's Hoodie",
    price: '$41.49',
    img: 'https://image.spreadshirtmedia.com/image-server/v1/products/T111A2PA4247PT17X49Y47D1058516213W25000H10560/views/1,width=500,height=500,appearanceId=2/dirty-birdy-logo-mens-hoodie.jpg',
    href: 'https://tweettwice.myspreadshop.com/dirty+birdy+logo-A69bdd52b8c78661dd89ca359?productType=111&sellable=J1LBzMg1dxHpM8Jla8ja-111-22&appearance=2',
  },
  {
    name: "Unisex Tri-Blend Organic Tank",
    price: '$25.49',
    img: 'https://image.spreadshirtmedia.com/image-server/v1/products/T2380A2PA4450PT17X2Y69D1058516213W25000H10560/views/1,width=500,height=500,appearanceId=2/dirty-birdy-logo-unisex-tri-blend-organic-tank.jpg',
    href: 'https://tweettwice.myspreadshop.com/dirty+birdy+logo-A69bdd52b8c78661dd89ca359?productType=2380&sellable=J1LBzMg1dxHpM8Jla8ja-2380-15&appearance=2',
  },
];

declare global {
  interface Window {
    spread_shop_config?: {
      shopName: string;
      locale: string;
      prefix: string;
      baseId: string;
    };
  }
}

export default function Store() {
  useEffect(() => {
    const existingScript = document.getElementById('spreadshop-script');
    if (existingScript) existingScript.remove();

    // Must set config BEFORE loading the script
    window.spread_shop_config = {
      shopName: 'tweettwice',
      locale: 'us_US',
      prefix: 'https://www.myspreadshop.com',
      baseId: 'spreadshop-container',
    };

    const script = document.createElement('script');
    script.id = 'spreadshop-script';
    script.type = 'text/javascript';
    script.src = 'https://www.myspreadshop.com/shopfiles/shopclient/shopclient.nocache.js';
    document.body.appendChild(script);

    return () => {
      const s = document.getElementById('spreadshop-script');
      if (s) s.remove();
      delete window.spread_shop_config;
    };
  }, []);

  return (
    <div className="bg-brand-dark min-h-screen">
      <Navbar />
      <main className="pt-20">
        {/* Hero */}
        <section className="relative py-20 px-6 md:px-12 overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://public.readdy.ai/ai/img_res/42af17abe79dc25bd4a38803d0781e37.jpg"
              alt=""
              className="w-full h-full object-cover object-center opacity-25"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-brand-dark/80 to-brand-dark" />
          </div>
          <div className="relative z-10 max-w-7xl mx-auto">
            <p className="font-heading text-brand-orange tracking-[0.3em] uppercase text-xs mb-2">Official Merch</p>
            <h1 className="font-display text-6xl md:text-7xl text-white tracking-wide mb-4">
              THE <span className="text-brand-yellow">STORE</span>
            </h1>
            <p className="font-body text-white/50 max-w-xl">Rep the brand. Print on demand — shipped worldwide via Spreadshop.</p>
          </div>
        </section>

        {/* Merch Design Showcase */}
        <section className="py-12 px-6 md:px-12 bg-brand-dark">
          <div className="max-w-7xl mx-auto mb-10">
            <p className="font-heading text-brand-orange tracking-[0.3em] uppercase text-xs mb-2">Design Preview</p>
            <h2 className="font-display text-4xl text-white tracking-wide mb-8">
              FEATURED <span className="text-brand-yellow">DESIGNS</span>
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5" data-product-shop>
              {MERCH_DESIGNS.map((item) => (
                <a
                  key={item.name}
                  href={item.href}
                  target="_blank"
                  rel="nofollow noreferrer"
                  className="group bg-brand-card overflow-hidden cursor-pointer block"
                >
                  <div className="relative w-full h-0 pb-[100%] overflow-hidden bg-white">
                    <img
                      src={item.img}
                      alt={item.name}
                      className="absolute inset-0 w-full h-full object-contain object-center transition-transform duration-500 group-hover:scale-105"
                    />
                  </div>
                  <div className="p-4 flex items-center justify-between">
                    <div>
                      <p className="font-heading text-white text-sm font-semibold">{item.name}</p>
                      <p className="font-display text-brand-yellow text-xl">{item.price}</p>
                    </div>
                    <div className="w-9 h-9 flex items-center justify-center bg-brand-yellow hover:bg-brand-orange transition-colors duration-200">
                      <i className="ri-shopping-cart-line text-black text-sm" />
                    </div>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </section>

        {/* Spreadshop Live Embed */}
        <section className="py-12 px-6 md:px-12 bg-[#111]">
          <div className="max-w-7xl mx-auto">
            <p className="font-heading text-brand-orange tracking-[0.3em] uppercase text-xs mb-2">Live Shop</p>
            <a href="https://tweettwice.myspreadshop.com/" target="_blank" rel="nofollow noreferrer" className="inline-block cursor-pointer">
              <h2 className="font-display text-4xl text-white tracking-wide mb-8 hover:text-brand-yellow transition-colors duration-200">
                SHOP <span className="text-brand-yellow">NOW</span>
              </h2>
            </a>
            <div id="spreadshop-container" className="min-h-[600px]">
              <a href="https://tweettwice.myspreadshop.com">tweettwice</a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
